export interface ProcessStep {
  phase: string;
  title: string;
  desc: string;
  accent: string;
  accentRgb: string;
  tag: string;
}

export const steps: ProcessStep[] = [
  {
    phase: "01",
    title: "Define",
    desc: "Every great experience starts with understanding. We deep-dive into your goals, audience, and environment to map out the smartest path forward.",
    accent: "#6366f1",
    accentRgb: "99,102,241",
    tag: "Discovery",
  },
  {
    phase: "02",
    title: "Design",
    desc: "Before we build, our team creates working prototypes and visual mockups so you can see, feel, and refine the experience. Rapid prototypes let us test concepts, validate feasibility, and refine direction before full production begins.",
    accent: "#a855f7",
    accentRgb: "168,85,247",
    tag: "Prototyping",
  },
  {
    phase: "03",
    title: "Deliver",
    desc: "We deliver, on time, on spec, on site. Our integrated teams handle fabrication, development, installation, and live operation so nothing falls between the cracks. From first install to final render, we own the process end to end.",
    accent: "#ec4899",
    accentRgb: "236,72,153",
    tag: "Execution",
  },
];
